import { Verifiable } from './verifiable';
import { AbstractControl, Validators } from '@angular/forms';

export class Document extends Verifiable {

    static validate(documentType: string) {
        return (control: AbstractControl): Validators => {
            const document = typeof control.value == 'string'? control.value.replace(/[^0-9]+/g, "") : '';

            if (!document) {
                return null;
            }

            switch (documentType) {
                case 'cpf':
                    return Document.validateCpf(document);
                case 'cnpj':
                    return Document.validateCnpj(document);
                default:
                    return { invalid: true, msg: 'Tamanho inválido' };
            }
        }
    }

    static validateCpf(cpf: string) {
        const invalido = { invalid: true, msg: 'CPF não é válido' };

        if (cpf.length < 11) {
            invalido.msg = 'CPF deve ter 11 números';
            return invalido;
        }
        // Verifica se todos os digitos do CPF são iguais. Se forem o CPF é inválido.
        let equalDigits: boolean = true;
        for (let i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
                equalDigits = false;
                break;
            }
        }

        if (equalDigits) {
            invalido.msg = 'CPF não pode ter todos os números iguais';
            return invalido;
        }


        /*
        let d = 2;
        do {
            let sum: number = 0;
            let numbers = cpf.substring(0, 11 - d);
            for (let i = numbers.length; i > 1; i--) {
                sum += Number(numbers.charAt(numbers.length + 1 - i)) * i;
            }
            let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
            if (result !== Number(digits.charAt(2 - d))) {
                return invalido;
            }
            d--;
        } while(d > 0);
        */
       
        var add = 0;
        var rev;

        for (var i=0; i < 9; i ++)		
            add += parseInt(cpf.charAt(i)) * (10 - i);

        rev = 11 - (add % 11);	
        if (rev == 10 || rev == 11)		
            rev = 0;
    
        if (rev != parseInt(cpf.charAt(9)))
            return invalido;		

        // Valida 2o digito	
        add = 0;	

        for (i = 0; i < 10; i ++)		
            add += parseInt(cpf.charAt(i)) * (11 - i);	

        rev = 11 - (add % 11);	

        if (rev == 10 || rev == 11)	
            rev = 0;	

        if (rev != parseInt(cpf.charAt(10)))
            return invalido;		

        return null;
    }

    static validateCnpj(cnpj: string) {

        const invalido = { invalid: true, msg: 'CNPJ não é válido' };

        cnpj = cnpj.replace(/[^\d]+/g,'');
 
        if(cnpj == '' || cnpj.length != 14)  
            return invalido;
        
        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" || 
            cnpj == "11111111111111" || 
            cnpj == "22222222222222" || 
            cnpj == "33333333333333" || 
            cnpj == "44444444444444" || 
            cnpj == "55555555555555" || 
            cnpj == "66666666666666" || 
            cnpj == "77777777777777" || 
            cnpj == "88888888888888" || 
            cnpj == "99999999999999")
            return invalido;
            
        // Valida DVs
        var tamanho = cnpj.length - 2
        var numeros:any = cnpj.substring(0,tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;

        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
        }

        var resultado:any = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado != digitos.charAt(0))
            return invalido;
            
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                    pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return invalido;
            
        return null;

    }

    constructor(public number: string = '', verified: boolean = false) {
        super(verified);
    }
}